<style>
  .cart>p.title{
    margin-top: 0;
  }
  .cart>p.title>input[type='button'] {
    float: right;
    background-color: #EAEAEA;
    border:0;
    font-size: 13px;
    padding-top: 3px;
    padding-bottom: 3px;
    cursor: pointer;
    margin-top: -2px;
  }
  .cart>ul.cart-lists{
    margin: 0;
    padding: 0;
    list-style-type: none;
  }
  .cart>ul.cart-lists>li:first-child {
    /*padding-top: 0;*/
  }
  .cart>ul.cart-lists>li:last-child {
    border:0;
  }
  .cart>ul.cart-lists>li{
    border-bottom: 1px solid #EAEAEA;
    padding: 12px 0;
  }
  .cart>.btn-submit{
    margin-top: 3px;
  }
  .cart-lists>li>span.name{
    min-width: 180px;
    display: inline-block;
  }
  .cart-lists>li>span.value {
    margin-left: 5px;
    background-color: #1376eb;
    color:white;
    font-weight: bold;
    border-radius: 3px;
    padding: 1px 8px;
    display: inline-block;
    width: 37px;
    margin-top: -2px;
    text-align: right;
    font-size: 12px;
    line-height: 16px;
  }
  .cart-lists>li>i.iconfont{
    font-size: 17px;
    padding: 3px;
    cursor: pointer;
    float: right;
    margin-top: -6px;
  }
  .cart>p.no-item{
    text-align: center;
    color: #cccccc;
    font-size: 12px;
    line-height: 74px;
  }
  .cart .submit-words .el-dialog--tiny{
    width: 420px;
  }
  .cart .submit-words .el-icon-circle-check{
    font-size: 42px;
    color:#13ce66;
  }
  .cart .submit-words span.tips{
    margin-left: 54px;
    display: block;
    margin-top: -29px;
  }
  .cart .btn-submit-words{
    width: 100%;
  }
  .cart .btn-submit-words .el-tooltip__rel {
    width: 100%;
  }
</style>

<template>
<div class="cart">
  <p class="title">
    <span>关键词列表 ({{carts.length}}) </span>
    <input type="button" value="清除" @click="clear()" />
  </p>
  <ul class="cart-lists" v-show="carts.length !== 0">
    <li class="clearfix" v-for="item in carts">
      <span class="name">{{item.keyword}}</span>
      <span class="value">{{item.sindex}}</span>
      <i class="iconfont icon-guanbi" @click="remove(item)"></i>
    </li>
  </ul>
  <p class="no-item" v-show="carts.length === 0">
    列表暂无添加关键词
  </p>
  <el-tooltip :disabled="!!user.uname" v-show="carts.length > 0" placement="top" content="登录才能导入/导出关键词哦。∩_∩" class="btn-submit-words">
    <el-button type="default" class="btn-block" @click="submit">提交关键词</el-button>
  </el-tooltip>
  <el-dialog title="提示" v-model="dialogVisible" size="tiny" class="submit-words">
    <i class="el-icon-circle-check"></i>
    <span class="tips">请在新页面中完成关键词提交</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resubmit">重新提交</el-button>
      <el-button type="primary" @click="done">完成</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'searchCart',
  computed: mapState({ user: state => {
    return state.user
  }}),
  props: {
    carts: [ Array ]
  },
  data () {
    return {
      dialogVisible: false
    }
  },
  methods: {
    remove (item) {
      this.$emit('removeToCart', item)
    },
    clear () {
      this.$emit('resetCart')
    },
    submit () {
      this.$router.push({
        name: 'order'
      })
    },
    resubmit () {
      window.open('http://admin.18show.cn')
    },
    done () {
      this.dialogVisible = false
      this.$emit('resetCart')
      // 如果不延迟可能造成数据无法重置
      setTimeout(() => {
        // this.$router.replace({ name: 'index' })
        window.location.href = '/'
      }, 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// cart.vue?7c8e5052